module.exports = __webpack_public_path__ + "bfe9e51331d30173bc0d1a7010040be9.png";